export default async function () {
  const carrierStore = useCarrierUsersStore();

  await carrierStore.fetchUsers();
}
